import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import classNames from "classnames"
import memo from "set-state-compare/build/memo"
import PropTypes from "prop-types"
import React from "react"
import {User} from "models"

/**
 * @typedef {object} ComponentsFrontLayoutTopMenuProps
 * @property {React.ReactNode} actions
 * @property {string} className
 * @property {User} currentUser
 * @property {unknown} layout
 * @property {React.ReactNode} leftActions
 * @property {unknown} userMenu
 */

/** @typedef {object} ComponentsFrontLayoutTopMenuState */

/**
 * @extends {ShapeComponent<ComponentsFrontLayoutTopMenuProps, ComponentsFrontLayoutTopMenuState>}
 */
class ComponentsFrontLayoutTopMenu extends ShapeComponent {
  static propTypes = {
    actions: PropTypes.node,
    className: PropTypes.string,
    currentUser: PropTypes.instanceOf(User),
    layout: PropTypes.string.isRequired,
    leftActions: PropTypes.node,
    userMenu: PropTypes.bool.isRequired
  }

  render() {
    const {actions, className, layout, leftActions, userMenu, ...restProps} = this.props

    return (
      <div className={classNames("components--front-layout--top-menu", className)} {...restProps}>
        <div className="top-menu-container">
          <div>
            {leftActions}
          </div>
          <div style={{display: "flex"}}>
            {actions}
          </div>
        </div>
      </div>
    )
  }
}

export default memo(shapeComponent(ComponentsFrontLayoutTopMenu))
